import { HubConnection } from '@microsoft/signalr'
import { AppDispatch } from '../types/store'
import { logOnSignalRMethodTrigger } from './lib/logOnSignalRMethodTrigger'
import { SignalRMethods } from './lib/SignalRMethods'
import { notificationsActions } from '../store/slices/notificationsSlice'

export const receiveNotifications = (
    connection: HubConnection,
    dispatch: AppDispatch
) => {
    connection.on(SignalRMethods.NEW_NOTIFICATIONS, (notifications) => {
        logOnSignalRMethodTrigger(
            SignalRMethods.NEW_NOTIFICATIONS,
            notifications
        )
        if (Array.isArray(notifications)) {
            dispatch(notificationsActions.newNotifications(notifications))
        }
    })
}
